import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { dmOfferType }                           from '../offertypes/xv-offertypes';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmDiscountType {
    DiscountTypeID:   number;
    DiscountTypeName: string;

    constructor(
         pDiscountTypeID:   number
        ,pDiscountTypeName: string
    ) {
        this.DiscountTypeID   = pDiscountTypeID;
        this.DiscountTypeName = pDiscountTypeName;
    }
}

export class CustomPackagesViewModel {
    ShowAlert:                   (pTitle: string, pMessage: string) => void;
    BackToSignIn:                ()                                 => void;
    NewLoading:                  (pMessage: string)                 => dmLoading;

    mlText:                      MLText;
    app:                         mlBroker;
    ml:                          mlBroker;
    Hotel:                       dmHotel;
    LangID:                      number;

    InAction:                    boolean;

    SelectedLangID:              number;
    SelectedLangCode:            string;
    SelectedOfferTypeID:         number;
    SelectedNameInViewLang:      string;
    SelectedOfferTypeName:       string;
    SelectedNameStored:          string;

    HasSelectedOfferType:        boolean;
    WithFreeText:                boolean;

    SelectedPaymentSchemeID:     number;
    SelectedOfferTypeAutoNameID: number;
    AddHasFreeText:              boolean;
    AddNameEn:                   string;

    PackageLevelAdvanceDays:     number;

    SelectedSourceOfferTypeID:   number;
    DiscountTypeID:              number;

    IsSurcharge:                 boolean;
    IsSurchargeLabel:            string;

    Surcharge:                   number;
    SourceMLOS:                  boolean;
    SourceMaxStay:               boolean;
    SourceAdvanceDays:           boolean;
    SourceNoArr:                 boolean;
    SourceNoDep:                 boolean;

    PaymentSchemes:              RQService.Pms.GetPaymentSchemesOTARow[];
    OfferTypeAutoNames:          RQService.Pms.GetOfferTypeAutoNamesRow[];
    OfferTypes:                  dmOfferType[];
    OfferTypesByID:              dmOfferType[];
    Languages:                   RQService.Pms.GetLanguagesRow[];
    SourceOfferTypes:            dmOfferType[];
    SourceOfferTypesByID:        dmOfferType[];
    DiscountTypes:               dmDiscountType[];
    DiscountTypesByID:           dmDiscountType[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText                      = pMLText;
        this.LangID                      = this.mlText.GetLangID();
        this.app                         = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                          = this.mlText.GetBroker(
            'HotelAreaDerivedPackages'
        );

        this.Hotel                       = pHotel;
        this.BackToSignIn                = pBackToSignIn;
        this.ShowAlert                   = pShowAlert;
        this.NewLoading                  = pNewLoading;

        this.InAction                    = true;
                                  
        this.SelectedLangID              = 1;
        this.SelectedLangCode            = 'en';
        this.SelectedOfferTypeID         = 0;
        this.SelectedNameInViewLang      = this.ml.Text(
             'NoRatePackageSelectedWithBrackets'
            ,'(No rate package selected)'
        );
        this.SelectedOfferTypeName       = '';
        this.SelectedNameStored          = '';

        this.HasSelectedOfferType        = false;
        this.WithFreeText                = false;

        this.SelectedPaymentSchemeID     = 0;
        this.SelectedOfferTypeAutoNameID = 0;

        this.AddHasFreeText              = false;
        this.AddNameEn                   = '';

        this.SelectedSourceOfferTypeID   = 0;
        this.DiscountTypeID              = 0;

        this.IsSurcharge                 = false;
        this.IsSurchargeLabel            = this.ml.Text('DiscountAmount' ,'Discount Amount');

        this.Surcharge                   = 0;
        this.SourceMLOS                  = true;
        this.SourceMaxStay               = false;
        this.SourceAdvanceDays           = false;
        this.SourceNoArr                 = false;
        this.SourceNoDep                 = false;

        this.PackageLevelAdvanceDays     = 0;

        this.PaymentSchemes              = [];
        this.OfferTypeAutoNames          = [];
        this.OfferTypes                  = [];
        this.OfferTypesByID              = [];
        this.Languages                   = [];
        this.SourceOfferTypes            = [];
        this.SourceOfferTypesByID        = [];
        this.DiscountTypes               = [];
        this.DiscountTypesByID           = [];

        let percentageType: dmDiscountType = new dmDiscountType(
             0
            ,this.ml.Text('PercentageModifier'  ,'Percentage Modifier')
        );

        let fixedType:      dmDiscountType = new dmDiscountType(
             1
            ,this.ml.Text('FixedPricePerPerson' ,'Fixed Price Per Person')
        );

        this.DiscountTypes.push(percentageType);
        this.DiscountTypes.push(fixedType);

        this.DiscountTypesByID[0] = percentageType;
        this.DiscountTypesByID[1] = fixedType;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let paymentSchemeParams = RQParam.PmsGetPaymentSchemesOTAParams();

            paymentSchemeParams.LangID = this.LangID;

            RQService.Pms.GetPaymentSchemesOTA(paymentSchemeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let paymentSchemes = response.RQueryResult;

                for (let i = 0; i < paymentSchemes.length; i++) {
                    let paymentScheme = RQService.Pms.PopulateGetPaymentSchemesOTARow(
                        paymentSchemes[i]
                    );
            
                    console.log('row push');
            
                    this.PaymentSchemes.push(paymentScheme);
                }

                let autoNameParams = RQParam.PmsGetOfferTypeAutoNamesParams();

                autoNameParams.LangID = this.LangID

                RQService.Pms.GetOfferTypeAutoNames(autoNameParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let autoNames = response.RQueryResult;

                    for (let i = 0; i < autoNames.length; i++) {
                        let autoName = RQService.Pms.PopulateGetOfferTypeAutoNamesRow(
                            autoNames[i]
                        );
            
                        console.log('row push');
            
                        this.OfferTypeAutoNames.push(autoName);
                    }

                    RQService.Pms.GetLanguages(
                        {}
                    ).then((result) => {
                        let response = result as any;
            
                        if (response.HasErrorOrException) { loading.Dismiss(); return; }
            
                        let languages = response.RQueryResult;
            
                        for (let i = 0; i < languages.length; i++) {
                            let language = RQService.Pms.PopulateGetLanguagesRow(
                                languages[i]
                            );
            
                            console.log('row push');
            
                            this.Languages.push(language);
                        }

                        let offerTypesParams = RQParam.PmsGetOfferTypesParams();

                        offerTypesParams.HotelID = this.Hotel.HotelID;
                        offerTypesParams.LangID  = this.LangID;

                        RQService.Pms.GetOfferTypes(offerTypesParams).then((result) => {
                            let response = result as any;

                            if (response.HasErrorOrException) { return; }

                            let offerTypes = response.RQueryResult;

                            for (let i = 0; i < offerTypes.length; i++) {
                                let offerType = new dmOfferType(
                                    RQService.Pms.PopulateGetOfferTypesRow(
                                        offerTypes[i]
                                    )
                                );

                                if (offerType.OfferType.IsDiscountFilter == 0) {
                                    console.log('row push');

                                    this.SourceOfferTypes.push(offerType);

                                    this.SourceOfferTypesByID[
                                        offerType.OfferType.OfferTypeID
                                    ] = offerType;
                                }
                            }

                            if (this.SourceOfferTypes.length == 1) {
                                this.SelectSourceOfferType(
                                    this.SourceOfferTypes[0].OfferType.OfferTypeID
                                );
                            }

                            this.refreshOfferTypes(() => {
                                loading.Dismiss();
            
                                this.InAction = false;
                            });
                        });
                    });
                });
            });
        });
    }

    private refreshOfferTypes(pAction: () => void) {
        let offerTypesParams = RQParam.PmsGetOfferTypesParams();

        offerTypesParams.HotelID   = this.Hotel.HotelID;
        offerTypesParams.LangID    = this.LangID;

        this.OfferTypes.length     = 0;
        this.OfferTypesByID.length = 0;

        RQService.Pms.GetOfferTypes(offerTypesParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let offerTypes = response.RQueryResult;

            for (let i = 0; i < offerTypes.length; i++) {
                let offerType = new dmOfferType(
                    RQService.Pms.PopulateGetOfferTypesRow(
                        offerTypes[i]
                    )
                );

                if (offerType.OfferType.IsDiscountFilter != 0) {
                    console.log('row push');

                    if (this.SourceOfferTypesByID[offerType.OfferType.SourceOfferTypeID]) {
                        offerType.SourceOfferTypeName = this.SourceOfferTypesByID[
                            offerType.OfferType.SourceOfferTypeID
                        ].OfferType.OfferTypeName;
                    }

                    if (this.DiscountTypesByID[offerType.OfferType.DiscountTypeID]) {
                        offerType.DiscountTypeName = this.DiscountTypesByID[
                            offerType.OfferType.DiscountTypeID
                        ].DiscountTypeName;

                        if (offerType.OfferType.DiscountTypeID == 0) {
                            offerType.DiscountDescription
                                = (offerType.OfferType.Surcharge < 0)
                                ? ((-1) * offerType.OfferType.Surcharge) + ' %'
                                :         offerType.OfferType.Surcharge  + ' %';
                        } else {
                            offerType.DiscountDescription
                                = (offerType.OfferType.Surcharge < 0)
                                ? ((-1) * offerType.OfferType.Surcharge).toString()
                                : offerType.OfferType.Surcharge.toString();
                        }
                    }

                    this.OfferTypes.push(offerType);
                    
                    this.OfferTypesByID[offerType.OfferType.OfferTypeID] = offerType;
                }
            }

            if (this.OfferTypesByID[this.SelectedOfferTypeID]) {
                this.selectOfferTypeInternal(
                     this.SelectedOfferTypeID
                    ,() => { pAction(); }
                );
            } else {
                this.HasSelectedOfferType   = false;
                this.WithFreeText           = false;
                this.SelectedOfferTypeID    = 0;
                this.SelectedNameInViewLang = this.ml.Text(
                     'NoRatePackageSelectedWithBrackets'
                    ,'(No rate package selected)'
                );
                this.SelectedOfferTypeName  = '';
                this.SelectedNameStored     = '';

                pAction();
            }
        });
    }

    private selectOfferTypeInternal(pOfferTypeID: number, pAction: () => void) {
        if (!this.OfferTypesByID[pOfferTypeID]) {
            this.HasSelectedOfferType = false;
            this.WithFreeText         = false;

            pAction();

            return;
        }

        this.SelectedOfferTypeID   = pOfferTypeID;

        let offerType: dmOfferType = this.OfferTypesByID[this.SelectedOfferTypeID];

        this.HasSelectedOfferType  = true;

        if (offerType.OfferType.OfferTypeAutoNameID > 0) { this.WithFreeText = false; }
        else                                             { this.WithFreeText = true;  }

        for (let i: number = 0; i < this.OfferTypes.length; i++) {
            if (offerType.OfferType.OfferTypeID == this.OfferTypes[i].OfferType.OfferTypeID) {
                this.OfferTypes[i].IsSelected = true;
            } else {
                this.OfferTypes[i].IsSelected = false;
            }
        }

        this.SelectedNameInViewLang = offerType.OfferType.OfferTypeName;

        if (this.SelectedLangID == this.LangID) {
            this.SelectedOfferTypeName = offerType.OfferType.OfferTypeName;
            this.SelectedNameStored    = this.SelectedOfferTypeName;

            pAction();
        } else {
            let offerTypeParams = RQParam.PmsGetOfferTypeParams();

            offerTypeParams.HotelID     = this.Hotel.HotelID;
            offerTypeParams.OfferTypeID = offerType.OfferType.OfferTypeID;
            offerTypeParams.LangID      = this.SelectedLangID;

            RQService.Pms.GetOfferType(offerTypeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let roomTypeML = RQService.Pms.PopulateGetOfferTypeRow(
                    response.RQueryResult[0]
                )

                this.SelectedOfferTypeName = roomTypeML.OfferTypeName;
                this.SelectedNameStored    = this.SelectedOfferTypeName;

                pAction();
            });
        }
    }

    public SelectLanguage(pLangID: number) {
        if (this.InAction) { return; }

        this.SelectedLangID   = pLangID;
        this.SelectedLangCode = this.Languages[(pLangID - 1)].LangISOCode;

        if (this.SelectedOfferTypeID != 0) {
            this.InAction = true;

            let loading   = this.NewLoading(
                this.app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                this.selectOfferTypeInternal(
                     this.SelectedOfferTypeID
                    ,() => {
                        loading.Dismiss();
                
                        this.InAction = false;
                    }
                );
            });
        }
    }

    public SelectOfferType(pOfferTypeID: number) {
        if (this.InAction) { return; }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.selectOfferTypeInternal(
                 pOfferTypeID
                ,() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                }
            );
        });
    }

    public SelectOfferTypeAutoName(pOfferTypeAutoNameID: number) {
        this.SelectedOfferTypeAutoNameID = pOfferTypeAutoNameID;
        this.PackageLevelAdvanceDays     = 0;

        if (pOfferTypeAutoNameID == 5) { this.PackageLevelAdvanceDays = 28; }

        for (let i: number = 0; i < this.OfferTypeAutoNames.length; i++) {
            let name = this.OfferTypeAutoNames[i];

            if (name.OfferTypeAutoNameID == pOfferTypeAutoNameID) {
                this.SelectedPaymentSchemeID = name.PaymentSchemeID;
            }
        }
    }

    public SelectSourceOfferType(pSourceOfferTypeID: number) {
        this.SelectedSourceOfferTypeID = pSourceOfferTypeID;
    }

    public SelectDiscountType(pDiscountTypeID: number) {
        this.DiscountTypeID = pDiscountTypeID;
    }

    public SelectPaymentScheme(pPaymentSchemeID: number) {
        this.SelectedPaymentSchemeID = pPaymentSchemeID;
    }

    public SelectIsSurcharge() {
        if (this.IsSurcharge) {
            this.IsSurchargeLabel = this.ml.Text('SurchargeAmount' ,'Surcharge Amount');
        } else {
            this.IsSurchargeLabel = this.ml.Text('DiscountAmount'  ,'Discount Amount');
        }
    }

    public SyncPaymentScheme() {
        if (!this.AddHasFreeText) {
            for (let i: number = 0; i < this.OfferTypeAutoNames.length; i++) {
                let name = this.OfferTypeAutoNames[i];

                if (name.OfferTypeAutoNameID == this.SelectedOfferTypeAutoNameID) {
                    this.SelectedPaymentSchemeID = name.PaymentSchemeID;
                }
            }
        } else {
            this.SelectedPaymentSchemeID = this.PaymentSchemes[0].PaymentSchemeID;
            this.PackageLevelAdvanceDays = 0;
        }
    }

    public DeleteOfferType(pOfferTypeID: number) {
        if (this.InAction) { return; }

        if (!this.OfferTypesByID[pOfferTypeID]) {
            this.HasSelectedOfferType = false;
            this.WithFreeText         = false;

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let offerType: dmOfferType = this.OfferTypesByID[pOfferTypeID];
            
            let deleteParams = RQParam.PmsDeleteOfferTypeParams();
            
            deleteParams.HotelID     = this.Hotel.HotelID;
            deleteParams.OfferTypeID = offerType.OfferType.OfferTypeID;
            deleteParams.LangID      = this.LangID;
            
            RQService.Pms.DeleteOfferType(deleteParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshOfferTypes(() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                });
            });
        });
    }

    public AddOfferType() {
        if (this.InAction) { return; }

        if (this.AddHasFreeText && this.AddNameEn == '') {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'CustomPackageNameEmpty'
                    ,'Custom package name cannot be empty'
                )
            );

            return;
        }

        if ((!this.AddHasFreeText) && (this.SelectedOfferTypeAutoNameID == 0)) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'NoCustomPackageNameSelected'
                    ,'No custom package name selected'
                )
            );

            return;
        }

        if (this.SelectedSourceOfferTypeID == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'NoParentPackageSelected'
                    ,'No parent package selected'
                )
            );

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        if (this.AddHasFreeText) { this.PackageLevelAdvanceDays = 0; }

        loading.Show(() => {
            let addParams = RQParam.PmsNewOfferTypeAsDiscountOTAParams();
            
            addParams.HotelID                    = this.Hotel.HotelID;
            addParams.RackRatePaymentSchemeID    = this.SelectedPaymentSchemeID;
            addParams.Credentials                = '';
            addParams.ReleaseDays                = 0;
            addParams.CancelConsumesAvailability = 0;
            addParams.OfferTypeName              = this.AddNameEn;
            addParams.OfferTypeDescription       = this.AddNameEn;
            addParams.OfferTypeAutoNameID        = (this.AddHasFreeText)
                                                 ? 0
                                                 : this.SelectedOfferTypeAutoNameID;
            addParams.SourceOfferTypeID          = this.SelectedSourceOfferTypeID;
            addParams.DiscountTypeID             = this.DiscountTypeID;
            addParams.Surcharge                  = (this.IsSurcharge)
                                                 ? this.Surcharge
                                                 : (-1) * this.Surcharge;
            addParams.SourceMLOS                 = (this.SourceMLOS)        ? 1 : 0;
            addParams.SourceMaxStay              = (this.SourceMaxStay)     ? 1 : 0;
            addParams.SourceAdvanceDays          = (this.SourceAdvanceDays) ? 1 : 0;
            addParams.SourceNoArr                = (this.SourceNoDep)       ? 1 : 0;
            addParams.SourceNoDep                = (this.SourceNoDep)       ? 1 : 0;
            addParams.SourceMaxPersons           = 0;
            addParams.InitialiseAllotmentToZero  = 0;
            addParams.PackageLevelAdvanceDays    = this.PackageLevelAdvanceDays;
            addParams.LangID                     = this.LangID;

            RQService.Pms.NewOfferTypeAsDiscountOTA(addParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) {
                    loading.Dismiss();
            
                    this.InAction = false;
            
                    return;
                }

                let newOfferTypeID: number = 0;

                let status = response.RQueryResult;

                if (
                    (status.length > 0)
                &&  (status[0].ReturnValue)
                &&  (!isNaN(Number(status[0].ReturnValue)))
                ) {
                    newOfferTypeID = Number(status[0].ReturnValue);
                }

                if (this.SourceOfferTypes.length == 1) {
                    this.SelectSourceOfferType(
                        this.SourceOfferTypes[0].OfferType.OfferTypeID
                    );
                } else {
                    this.SelectedSourceOfferTypeID = 0;
                }

                this.SelectedPaymentSchemeID     = 0;
                this.SelectedOfferTypeAutoNameID = 0;
            
                this.AddHasFreeText              = false;
                this.AddNameEn                   = '';

                this.IsSurcharge                 = false;
                this.IsSurchargeLabel            = this.ml.Text(
                     'DiscountAmount'
                    ,'Discount Amount'
                );

                this.Surcharge                   = 0;
                this.DiscountTypeID              = 0;

                this.SourceMLOS                  = true;
                this.SourceMaxStay               = false;
                this.SourceAdvanceDays           = false;
                this.SourceNoArr                 = false;
                this.SourceNoDep                 = false;

                this.refreshOfferTypes(() => {
                    this.selectOfferTypeInternal(
                         newOfferTypeID
                        ,() => {
                            loading.Dismiss();
            
                            this.InAction = false;
                        }
                    );
                });
            });
        });
    }

    public EditOfferTypeName() {
        if (this.InAction) { return; }

        if (!this.OfferTypesByID[this.SelectedOfferTypeID]) {
            this.HasSelectedOfferType = false;
            this.WithFreeText         = false;

            return;
        }

        let offerType: dmOfferType = this.OfferTypesByID[this.SelectedOfferTypeID];

        if (offerType.OfferType.OfferTypeAutoNameID > 0) { return; }

        if (this.SelectedOfferTypeName == '') {
            this.ShowAlert(
                 this.ml.Text('CantEditCustomPackageName' ,'Cannot Edit Custom Package Name')
                ,this.ml.Text('CustomPackageNameEmpty'    ,'Custom package name cannot be empty')
            );

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let editNameParams = RQParam.PmsEditOfferTypeNameParams();
           
            editNameParams.HotelID       = this.Hotel.HotelID;
            editNameParams.OfferTypeID   = offerType.OfferType.OfferTypeID;
            editNameParams.OfferTypeName = this.SelectedOfferTypeName;
            editNameParams.LangID        = this.SelectedLangID;
           
            RQService.Pms.EditOfferTypeName(editNameParams).then((result) => {
                let response = result as any;
           
                if (response.HasErrorOrException) {
                    this.SelectedOfferTypeName = this.SelectedNameStored;
                } else {
                    this.SelectedNameStored    = this.SelectedOfferTypeName;
                }
           
                if (this.SelectedLangID == this.LangID) {
                    this.refreshOfferTypes(() => {
                        loading.Dismiss();
           
                        this.InAction = false;
                    });
                } else {
                    loading.Dismiss();
           
                    this.InAction = false;
                }
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/custom-packages/xv-custom-packages.ts